/**
 * Utility for place name translations (Frisian-Dutch, International-Dutch)
 */

export const FRISIAN_DUTCH_MAPPING: Record<string, string> = {
    "Ealsum": "Aalsum",
    "Abbegea": "Abbega",
    "Jewier": "Abbewier",
    "Eagum": "Aegum",
    "Ikkerwâld": "Akkerwoude",
    "Eagmaryp": "Akmarijp",
    "Allardseach": "Allardsoog",
    "Eanjum": "Anjum",
    "Annebuorren": "Anneburen",
    "Appelskea": "Appelscha",
    "Atsebuorren": "Atzeburen",
    "Augsbuert-Lytsewâld": "Augsbuurt",
    "Stynsgea": "Augustinusga",
    "Baarderbuorren": "Baarderburen",
    "Baaium": "Baijum",
    "Bakhuzen": "Bakhuizen",
    "Bakkefean": "Bakkeveen",
    "Bantegea": "Bantega",
    "Bears": "Beers",
    "Bitgum": "Beetgum",
    "Bitgummole": "Beetgumermolen",
    "Beetstersweach": "Beetsterzwaag",
    "Burgum": "Bergum",
    "Berltsum": "Berlikum",
    "Burdaard": "Birdaard",
    "Blauhûs": "Blauwhuis",
    "Blauforlaet": "Blauwverlaat",
    "Blije": "Blija",
    "Boatebuorren": "Boteburen",
    "Boelensloane": "Boelenslaan",
    "Boyl": "Boijl",
    "Bollingwier": "Bollingawier",
    "Boarnburgum": "Boornbergum",
    "Boarnsweach": "Boornzwaag",
    "Boarnwert": "Bornwird",
    "Boarnwerthuzen": "Bornwirdhuizen",
    "Boazum": "Bozum",
    "Breesândyk": "Breezanddijk",
    "Britswert": "Britswert",
    "Broeksterwâld": "Broeksterwoude",
    "Brongergea": "Brongerga",
    "Bûtenpost": "Buitenpost",
    "Bueren": "Buren",
    "Burchwert": "Burgwerd",
    "Bouwekleaster": "Buweklooster",
    "Kanada": "Canada",
    "Koarnjum": "Cornjum",
    "Koarnwert": "Cornwerd",
    "Damwâld": "Damwoude",
    "Dantumawâld": "Dantumawoude",
    "De Knipe": "De Knijpe",
    "De Lêste Stoer": "De Laatste Stuiver",
    "De Ryp": "De Rijp",
    "De Falom": "De Valom",
    "De Feanhoop": "De Veenhoop",
    "De Wylgen": "De Wilgen",
    "Dedzjum": "Dedgum",
    "Dearsum": "Deersum",
    "Delbuorren": "Delburen",
    "Dolsterhuzen": "Delfstrahuizen",
    "Diken": "Dijken",
    "Dykshoarne": "Dijkshorne",
    "Dokkumer Nije Silen": "Dokkumer Nieuwe Zijlen",
    "Doanjum": "Dongjum",
    "Dunegea": "Doniaga",
    "Drachtster Kompenije": "Drachtstercompagnie",
    "Trijeboerehuzen": "Drieboerehuizen",
    "Driezum": "Driesum",
    "Droegeham": "Drogeham",
    "Dronryp": "Dronrijp",
    "Ychten": "Echten",
    "Ychtenbrêge": "Echtenerbrug",
    "Iens": "Edens",
    "Ie": "Ee",
    "Earnewâld": "Eernewoude",
    "Jistergea": "Eesterga",
    "Jistrum": "Eestrum",
    "De Bult": "Eilanderbult",
    "Ealahuzen": "Elahuizen",
    "Ingelum": "Engelum",
    "Ingwierrum": "Engwierum",
    "Eksmoarre": "Exmorra",
    "Eksmoardersyl": "Exmorrazijl",
    "Ferwert": "Ferwerd",
    "Ferwâlde": "Ferwoude",
    "Finkebuorren": "Finkeburen",
    "Feinsum": "Finkum",
    "Furdgum": "Firdgum",
    "Flânsum": "Flansum",
    "Follegea": "Follega",
    "Folsgeare": "Folsgare",
    "Formearum": "Formerum",
    "Frjentsjer": "Franeker",
    "Fryske Peallen": "Frieschepalen",
    "De Gaastmar": "Gaastmeer",
    "Garyp": "Garijp",
    "Gau": "Gauw",
    "Ginnum": "Genum",
    "Gerkeskleaster-Strobos": "Gerkesklooster-Stroobos",
    "Gersleat": "Gersloot",
    "Gytsjerk": "Giekerk",
    "Goaiïngea": "Goënga",
    "Goaiïngahuzen": "Goëngahuizen",
    "Goaiïngaryp": "Goingarijp",
    "De Gordyk": "Gorredijk",
    "Grou": "Grouw",
    "Hallumerhoeke": "Hallumerhoek",
    "Hamsherne": "Hamshorn",
    "Hantumerútbuorren": "Hantumeruitburen",
    "Hantumerhoeke": "Hantumerhoek",
    "Hantumhuzen": "Hantumhuizen",
    "Hurdegaryp": "Hardegarijp",
    "De Harkema": "Harkema",
    "Harns": "Harlingen",
    "Hartwert": "Hartwerd",
    "Haskerdiken": "Haskerdijken",
    "Haskerhoarne": "Haskerhorne",
    "Haulerwyk": "Haulerwijk",
    "Heech": "Heeg",
    "It Hearrenfean": "Heerenveen",
    "Himmelum": "Hemelum",
    "Himpens": "Hempens",
    "De Himrik": "Hemrik",
    "Himrikerferlaat": "Hemrikerverlaat",
    "Hinnaard": "Hennaard",
    "Hjerbeam": "Herbaijum",
    "Hilaard": "Hijlaard",
    "Hylpen": "Hindeloopen",
    "Hitsum": "Hitzum",
    "Hegebeintum": "Hogebeintum",
    "Holwert": "Holwerd",
    "De Hommerts": "Hommerts",
    "It Heechsân": "Hoogzand",
    "Hoarnstersweach": "Hoornsterzwaag",
    "De Houtigehage": "Houtigehage",
    "Húns": "Huins",
    "Idaerd": "Idaard",
    "Skuzum": "Idsegahuizum",
    "Jiskenhuzen": "Idskenhuizen",
    "Idzegea": "Idzega",
    "Drylts": "IJlst",
    "Ysbrechtum": "IJsbrechtum",
    "Yndyk": "Indijk",
    "Jirnsum": "Irnsum",
    "Jannum": "Janum",
    "Jonkerslân": "Jonkersland",
    "Jorwert": "Jorwerd",
    "De Jouwer": "Joure",
    "Jobbegea": "Jubbega",
    "Jutryp": "Jutrijp",
    "Ketlik": "Katlijk",
    "Kimswert": "Kimswerd",
    "Kinum": "Kinnum",
    "De Lytse Geast": "Kleinegeest",
    "Kletterbuorren": "Kletterbuurt",
    "Kleaster Anjum": "Klooster Anjum",
    "Kleaster-Lidlum": "Klooster-Lidlum",
    "Kolderwâlde": "Kolderwolde",
    "Kollumersweach": "Kollumerzwaag",
    "Koatstertille": "Kootstertille",
    "Koarnwertersân": "Kornwerderzand",
    "Koartehimmen": "Kortehemmen",
    "Koartwâld": "Kortwoude",
    "Kûbaard": "Kubaard",
    "Kûkherne": "Kuikhorne",
    "Laaksum": "Laaxum",
    "Langsweagen": "Langezwaag",
    "Langwar": "Langweer",
    "Ljouwert": "Leeuwarden",
    "Legemar": "Legemeer",
    "De Lemmer": "Lemmer",
    "Ljussens": "Lioessens",
    "Leons": "Lions",
    "Loiïngea": "Loënga",
    "Lúnbert": "Luinjeberd",
    "Lytsepost": "Lutkepost",
    "Lytsewierrum": "Lutkewierum",
    "Lúkswâld": "Luxwoude",
    "Makkingea": "Makkinga",
    "Marsum": "Marssum",
    "Menaam": "Menaldum",
    "Mitselwier": "Metslawier",
    "Middelbuorren": "Middelburen",
    "Mullum": "Midlum",
    "Midsbuorren": "Midsburen",
    "Mildaam": "Mildam",
    "Minnertsgea": "Minnertsga",
    "Murns": "Mirns",
    "Mûnein": "Molenend",
    "Molkwar": "Molkwerum",
    "Moarre": "Morra",
    "Munnikebuorren": "Munnekeburen",
    "Nijewier": "Niawier",
    "Nijebrêge": "Nieuwebrug",
    "Nijhoarne": "Nieuwehorne",
    "Nijskoat": "Nieuweschoot",
    "Nyegea": "Nijega",
    "Nijemardum": "Nijemirdum",
    "Nijhuzum": "Nijhuizum",
    "Nijlân": "Nijland",
    "Noardburgum": "Noordbergum",
    "Oentsjerk": "Oenkerk",
    "Offenwier": "Offingawier",
    "Aldeboarn": "Oldeboorn",
    "Alde Ouwer": "Oldeouwer",
    "Easterbierrum": "Oosterbierum",
    "Easterein": "Oosterend",
    "Easterlittens": "Oosterlittens",
    "Eastermar": "Oostermeer",
    "Easternijtsjerk": "Oosternijkerk",
    "Easterwierrum": "Oosterwierum",
    "Easterwâlde": "Oosterwolde",
    "Eastersee": "Oosterzee",
    "Eastersee-Buorren": "Oosterzee-Buren",
    "Easthim": "Oosthem",
    "De Skâns-Oostmahorn": "Oostmahorn",
    "Eastrum": "Oostrum",
    "De Pein": "Opeinde",
    "Ophûs": "Ophuis",
    "Toppenhuzen": "Oppenhuizen",
    "Oranjewâld": "Oranjewoud",
    "Aldeleie": "Oude Leije",
    "Aldskou": "Oude Schouw",
    "Ouwe-Syl": "Oudebildtzijl",
    "Aldegea": "Oudega",
    "Aldehaske": "Oudehaske",
    "Aldhoarne": "Oudehorne",
    "Aldemardum": "Oudemirdum",
    "Aldskoat": "Oudeschoot",
    "Aldtsjerk": "Oudkerk",
    "Aldwâld": "Oudwoude",
    "Ousterhaule": "Ouwsterhaule",
    "Ousternijegea": "Ouwster-Nijega",
    "Peazens": "Paesens",
    "Parregea": "Parrega",
    "Pitersbierrum": "Pietersbierum",
    "Penjum": "Pingjum",
    "Poppenwier": "Poppingawier",
    "Raerd": "Rauwerd",
    "Reidswâl": "Reidswal",
    "Rie": "Ried",
    "Ryptsjerk": "Rijperkerk",
    "Riis": "Rijs",
    "Rinsumageast": "Rinsumageest",
    "Ritsumasyl": "Ritsumazijl",
    "Reahel": "Rohel",
    "Reahûs": "Roodhuis",
    "Readtsjerk": "Roodkerk",
    "Reduzum": "Roordahuizum",
    "Roptasyl": "Roptazijl",
    "Rottefalle": "Rottevalle",
    "Rûgehuzen": "Ruigahuizen",
    "Sânfurd": "Sandfirden",
    "Skalsum": "Schalsum",
    "Skarl": "Scharl",
    "Skearnegoutum": "Scharnegoutum",
    "Skarsterbrêge": "Scharsterbrug",
    "Skettens": "Schettens",
    "Skingen": "Schingen",
    "Skraard": "Schraard",
    "Skrins": "Schrins",
    "Skûlenboarch": "Schuilenburg",
    "Skuorregea": "Schurega",
    "Seisbierrum": "Sexbierum",
    "Sigerswâld": "Siegerswoude",
    "Sibrandabuorren": "Sijbrandaburen",
    "Sibrandahûs": "Sijbrandahuis",
    "Sleat": "Sloten",
    "Smelle Ie": "Smalle Ee",
    "Smelbrêge": "Smallebrugge",
    "Snakkerbuorren": "Snakkerburen",
    "Snits": "Sneek",
    "Sniksweach": "Snikzwaag",
    "Starum": "Stavoren",
    "Stryp": "Striep",
    "Sumar": "Suameer",
    "Suwâld": "Suawoude",
    "Surhústerfean": "Surhuisterveen",
    "Surhuzem": "Surhuizum",
    "Teard": "Teerd",
    "Tearns": "Teerns",
    "Teatlum": "Teetlum",
    "Terbant": "Terband",
    "Tergrêft": "Tergracht",
    "Terherne": "Terhorne",
    "Tersoal": "Terzool",
    "De Tibben": "Tibma",
    "Tichelwurk": "Tichelwerk",
    "Tytsjerk": "Tietjerk",
    "De Tynje": "Tijnje",
    "Turns": "Tirns",
    "Tsjalhuzum": "Tjalhuizum",
    "Tsjalbert": "Tjalleberd",
    "Tsjeintgum": "Tjeintgum",
    "Tsjerkgaast": "Tjerkgaast",
    "Tsjerkwert": "Tjerkwerd",
    "De Trieme": "Triemen",
    "Twizel": "Twijzel",
    "Tsjom": "Tzum",
    "Tsjummearum": "Tzummarum",
    "De Ulesprong": "Uilesprong",
    "Twellingea": "Uitwellingerga",
    "Oerterp": "Ureterp",
    "Oerterp oan de Feart": "Ureterp aan de Vaart",
    "Feankleaster": "Veenklooster",
    "Feanwâlden": "Veenwouden",
    "Feanwâldsterwâl": "Veenwoudsterwal",
    "Vegelinsoard": "Vegelinsoord",
    "Fjildbuorren": "Veldburen",
    "Fiskbuorren": "Visbuurt",
    "Buerstermûne": "Vrouwbuurtstermolen",
    "Froubuurt": "Vrouwenparochie",
    "Waaksens": "Waaxens",
    "Wânswert": "Wanswerd",
    "Warfstermûne": "Warfstermolen",
    "Wergea": "Warga",
    "Warten": "Wartena",
    "Waskemar": "Waskemeer",
    "Wjelsryp": "Welsrijp",
    "Westergeast": "Westergeest",
    "Littenserbuorren": "Westerlittens",
    "Westernijtsjerk": "Westernijkerk",
    "Westhim": "Westhem",
    "Wiuwert": "Wieuwerd",
    "Wikel": "Wijckel",
    "Winaem": "Wijnaldum",
    "Wynjewâld": "Wijnjewoude",
    "Wyns": "Wijns",
    "Wurdum": "Wirdum",
    "Wytmarsum": "Witmarsum",
    "Wytfean": "Witveen",
    "Wolvegea": "Wolvega",
    "Wûns": "Wons",
    "Warkum": "Workum",
    "Wâldsein": "Woudsend",
    "Wâlterswâld": "Wouterswoude",
    "Wytgaard": "Wijtgaard",
    "Ypekolsgea": "Ypecolsga",
    "Sânhuzen": "Zandhuizen",
    "Surch": "Zurich",
    "De Westereen": "Zwaagwesteinde",
    "Sweagerbosk": "Zwagerbosch",
    "Sweins": "Zweins",
    "Paris": "Parijs",
    "Lille": "Rijsel",
    "Antwerp": "Antwerpen",
    "Anvers": "Antwerpen",
    "Liège": "Luik",
    "Brussels": "Brussel",
    "Bruxelles": "Brussel",
    "Fryslân": "Friesland",
    "Frankrijk": "FR",
    "France": "FR",
    "België": "BE",
    "Belgie": "BE",
    "Belgium": "BE",
    "Nederland": "NL",
    "Netherlands": "NL",
    "Duitsland": "DE",
    "Germany": "DE",
    "United Kingdom": "UK",
    "UK": "UK",
    "Engeland": "UK",
    "United States": "US",
    "USA": "US"
};

/**
 * Reverse mapping for searching bi-directionally
 */
export const DUTCH_FRISIAN_MAPPING: Record<string, string> = Object.entries(FRISIAN_DUTCH_MAPPING).reduce((acc, [f, d]) => {
    acc[d] = f;
    return acc;
}, {} as Record<string, string>);

// Case-insensitive lookup maps
const NORMALIZED_FRISIAN_DUTCH: Record<string, string> = Object.entries(FRISIAN_DUTCH_MAPPING).reduce((acc, [f, d]) => {
    acc[f.toLowerCase()] = d;
    return acc;
}, {} as Record<string, string>);

const NORMALIZED_DUTCH_FRISIAN: Record<string, string> = Object.entries(DUTCH_FRISIAN_MAPPING).reduce((acc, [d, f]) => {
    acc[d.toLowerCase()] = f;
    return acc;
}, {} as Record<string, string>);

/**
 * Get equivalent name for search (case-insensitive)
 * @param name Place name to transform
 * @returns Equivalent name or original if no mapping exists
 */
export function getAlternatePlaceName(name: string): string | null {
    if (!name) return null;
    const lower = name.toLowerCase();
    return NORMALIZED_FRISIAN_DUTCH[lower] || NORMALIZED_DUTCH_FRISIAN[lower] || null;
}
